<template>
	<div class="body">
		<div class="industry-container">

			<div class="tab-ctr">
				<label v-for="(item,index) in tabList" :class="['tab-item', index == tabIndex ? 'tab-item-s' : '']"
					:key="index" @click="clickAddTab(index)">{{item.name}}</label>
			</div>

			<div class="industry-cnt-ctr">
				<el-form :inline="true">
					<el-form-item label="省直辖市">
						<el-select class="select-width" v-model="province" placeholder="请选择" :clearable=true
							@change="changeProvince">
							<el-option v-for="item in provinceList" :key="item.province_code"
								:label="item.province_name" :value="item.province_code">
							</el-option>
						</el-select>
					</el-form-item>
				<!-- 	<el-form-item label="地级市">
						<el-select class="select-width" v-model="city" placeholder="请选择" :clearable=true>
							<el-option v-for="item in cityList" :key="item.city_code" :label="item.city_name"
								:value="item.city_code">
							</el-option>
						</el-select>
					</el-form-item> -->
				</el-form>

				<el-table border :data="dataList">
					<el-table-column label="名称" align="center" prop="name" />
					<el-table-column label="省直辖市" align="center" prop="province_name" />
					<el-table-column label="操作" align="center" prop="college_name">
						<template v-slot="{ row }">
							<el-button type="primary" icon="el-icon-download" size="small"
								@click="clickRoute(row)">下载</el-button>
						</template>
					</el-table-column>
				</el-table>

				<div class="pagination">
					<pagination v-show="total>0" :total="total" :page.sync="queryParams.page"
						:limit.sync="queryParams.pageSize" @pagination="queryMajorAcademy" />
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import {
		getAddrTree,
	} from "@/api/matrix"

	import {
		getIndustryData
	} from "@/api/service"

	import {
		isEmpty
	} from "@/utils/util"

	import {
		parse,handleProtocal,handleRouteProtocal
	} from "@/utils/protocal"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	export default {
		name: "Matrix",
		data() {
			return {

				tabList: [{
						'name': '生成总值',
						'value': 'all'
					},
					{
						'name': '就业人口',
						'value': 'people'
					},
				],

				groupAddState: 2,
				tabIndex: 0,
				dataList: [],
				province: '',
				queryParams: {
					page: 1,
					pageSize: 20
				},
			}
		},
		created() {
			console.log('params', this.$route.query)
			this.initPageData();
		},
	
		methods: {
			initPageData() {
				this.requestData();
				this.loadProvince();
			},
			
			requestData(){
				this.initParams();
				getIndustryData(this.queryParams).then(res => {
					this.dataList = res.data.list;
					this.total = res.data.pageData.totalCount;
				});
			},
			
			initParams(){
				this.queryParams['type'] = this.tabList[this.tabIndex]['value'];
				this.queryParams['province_code'] = this.province;
			},

			initPassParams() {
				let params = this.$route.query
				console.log('initPassParams params', params)

			},
			
			
			changeProvince(value) {
				console.log('province: ', value);
				// this.provinceList.forEach(element => {
				// 	if (element.province_code == value) {
				// 		this.cityList = element.list;
				// 	}
				// });
				this.requestData();
			},

			loadProvince() {
				getAddrTree().then(res => {
					this.provinceList = res.data.tree;
				});
			},
			
			clickAddTab(index) {
				this.queryParams.page = 1;
				this.tabIndex = index;
	
				this.requestData();
			},


			clickRoute(item) {
				console.log('item', item)
				let data = parse(item.url)
				
				if(data['head'] == 'replace'){
					let url = "/" + data['path'];
					if (data['data'] != null && data['data'].length != 0) {
						url += "?" + data['data'];
					}
					console.log('url', url)
					// this.$router.replace(url);
					this.$router.push(url);
				}else{
					handleRouteProtocal(data)
				}
			},


		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "industry.scss";
</style>